import React,{useState ,useEffect} from "react";
import "./styles/style.css";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import "react-multi-date-picker/styles/layouts/mobile.css";

const CustomDatePicker = ({ val, handleChange, lable, disabled }) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="w-100">
      <div>
        <label
          className={`${disabled ? "datePickerDisabled" : ""} datePickerLabel`}
        >
          {lable}
        </label>
      </div>
      <DatePicker
        containerClassName="custom-container"
        calendar={persian}
        locale={persian_fa}
        calendarPosition="bottom-right"
        value={val.date}
        onChange={handleChange}
        format="YYYY/MM/DD"
       className={isMobile ? "rmdp-mobile" : ""}
        // responsive
        disabled={disabled}
      />
    </div>
  );
};

export default CustomDatePicker;
